module.exports = "<p>\n  forgot works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /home/dfm/cryosoft/ui/src/app/authentication/forgot/forgot.component.html
// module id = ../../../../../src/app/authentication/forgot/forgot.component.html
// module chunks = main